import { render, staticRenderFns } from "./AsideBar.vue?vue&type=template&id=4d9889ac&scoped=true&lang=true&"
import script from "./AsideBar.vue?vue&type=script&lang=js&"
export * from "./AsideBar.vue?vue&type=script&lang=js&"
import style0 from "./AsideBar.vue?vue&type=style&index=0&id=4d9889ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9889ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBadge,VList,VListItem,VNavigationDrawer})
